import { render } from "./SettingModal.vue?vue&type=template&id=287b94fc&scoped=true"
import script from "./SettingModal.vue?vue&type=script&lang=js"
export * from "./SettingModal.vue?vue&type=script&lang=js"

import "./SettingModal.vue?vue&type=style&index=0&id=287b94fc&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287b94fc"]])

export default __exports__